import { JDLBS, JDLocation, JDPermission } from '@jdreact/jdreact-core-lib';
import { getLatLngForWeb } from './forweb';
import { manualRequestLocationPermissionForWeb } from './getlatLngForWeb';
import { isIOS, isWeb, isSupportSceneId } from './utils';

const SCENE_CONTENT = null;

const BIZ_ID = 'b7c557f02eb969e6876b88d794e88a27';
const SCENE_ID = 'basicShoppingProcess';
let toastcontent = '';
// const PermissionStatus = {
//     granted: '200',
//     systemDennied: '201',
//     sceneDennied: '202',
//     unKnown: '203'
// };

// 请求定位授权
const requestLocationPermission = async(businessId) => {
    const isSupportSceneIdFlag = await isSupportSceneId();
    toast('检查是否支持sceneId' + isSupportSceneIdFlag);
    // ios所有版本和安卓11.6.5以下不支持sceneId, 用老方法
    if (!isSupportSceneIdFlag) {
        return new Promise(async(resolve, reject) => {
            if (isIOS) {
                JDLocation.requestLocationPermission(() => null, () => null);
                // 轮询检查授权状态
                let timer = setInterval(() => {
                    JDLBS.getLocationPermissionStatus((data) => {
                        if (data && data.status !== 'NotDetermined') {
                            clearInterval(timer);
                        } else {
                            return;
                        }

                        // 选择后进行判断授权
                        if (data && data.status === 'Authorized') {
                            JDLBS.getLatLng({ businessId }, location => {
                                return resolve({
                                    lon: isIOS ? location.longitude : location.longi,
                                    lat: isIOS ? location.latitude : location.lati
                                });
                            }, (e) => {
                                return reject(e);
                            }, null);
                        } else {
                            return reject(data);
                        }
                    }, (e) => {
                        clearInterval(timer);
                        return reject(e);
                    });
                }, 500);
            } else {
                let tittleMsg = ['位置权限', '位置权限'];
                toast('安卓低版本请求授权');
                let tipMsg = ['京东需要获取您的位置信息，以便向您展示附近线下门店、快递配送服务、商品库存等准确信息。您有权拒绝或者取消授权，取消后不影响您使用其他服务', ''];
                let permissions = ['android.permission.ACCESS_COARSE_LOCATION', 'android.permission.ACCESS_FINE_LOCATION'];
                let isInitiative = true;

                const requestParam = {
                    'moduleName': 'JDReactLib',
                    'tittleMsg': tittleMsg,
                    'tipMsg': tipMsg,
                    'permissions': permissions,
                    'isInitiative': isInitiative
                };
                try {
                    const requestResult = await JDPermission.newRequestPermission(requestParam);
                    resolve(requestResult);
                } catch (e) {
                    reject(e);
                }
            }
        });
    }

    toast('开始调用授权弹窗');
    return new Promise((resolve, reject) => {
        JDLBS.requestLocationPermissionWithScene({ businessId, sceneId: SCENE_ID }).then((flag) => {
            console.log('请求授权成功');
            toast('请求授权成功');
            resolve(flag);
        }).catch((err) => {
            console.log('请求授权失败', JSON.stringify(err));
            toast('请求授权失败', JSON.stringify(err));
            reject(err);
            // 0 跳转权限设置 -1 拒绝 -2 取消弹窗 -3 忽略（已多次拒绝）
            // -4 场景授权拒绝 -5 未弹窗（已有权限 or 未传sceneId or 距离上次申请不满48小时）
        });
    });
};

// 手动获取定位授权, 不受48小时限制
const manualRequestLocationPermission = async(businessId) => {
    if (isWeb) {
        return manualRequestLocationPermissionForWeb(businessId);
    }
    const isSupportSceneIdFlag = await isSupportSceneId().catch(() => false);
    return new Promise((resolve, reject) => {
        if (!isSupportSceneIdFlag) {
            toast('getJDAppCacheLatLng不支持sceneId');
            reject(new Error('getJDAppCacheLatLng不支持sceneId'));
        }
        JDLBS.manualRequestLocationPermissionWithScene({ businessId, sceneId: SCENE_ID, sceneContent: SCENE_CONTENT })
            .then((data) => {
                toast('getJDAppCacheLatLng手动调用弹窗成功');
                resolve(data);
            }).catch((err) => {
                toast('getJDAppCacheLatLng手动调用弹窗失败' + JSON.stringify(err));
                reject(err);
                // 0 跳转权限设置 -1 拒绝 -2 取消弹窗 -3 忽略（已多次拒绝）
                // -4 场景授权拒绝 -5 未弹窗（已有权限 or 未传sceneId）
            });
    });
};

// 获取主站定位缓存
const getJDAppCacheLatLng = (businessId) => {
    return new Promise((resolve, reject) => {
        JDLBS.getLastLocation({ businessId: businessId, sceneId: SCENE_ID }, location => {
            const jdCacheLocation = mapLocationParams(location);
            console.log('获取到缓存定位');
            resolve(jdCacheLocation);
        }, (err) => {
            toast('getJDAppCacheLatLng获取到主站缓存发生错误' + JSON.stringify(err));
            reject(err);
        }, null);
    });
};

// 获取当前定位
const getCurrentLatLng = (businessId) => {
    return new Promise((resolve, reject) => {
        JDLBS.getLatLng({ businessId, sceneId: SCENE_ID }, location => {
            const currentLocation = mapLocationParams(location);
            toast('getCurrentLatLng获取到实时定位' + JSON.stringify(currentLocation));
            return resolve(currentLocation);
        }, err => {
            toast('getCurrentLatLng没有拿到实时定位' + JSON.stringify(err.message));
            requestLocationPermission(businessId).then(() => {
                toast('getCurrentLatLng获取定位权限成功');
                // 请求完定位权限, 再获取一次定位
                JDLBS.getLatLng({ businessId, sceneId: SCENE_ID }, location => {
                    const currentLocation = mapLocationParams(location);
                    toast('getCurrentLatLng获取定位权限成功' + JSON.stringify(currentLocation));
                    return resolve(currentLocation);
                }, err => {
                    toast('getCurrentLatLng获取定位权限成功, 但是获取实时定位失败' + JSON.stringify(err));
                    return reject(err);
                });
            }).catch((err) => {
                toast('getCurrentLatLng获取定位权限失败' + JSON.stringify(err));
                return reject(err);
            });
        });
    });
};

// 字段名映射
// 安卓: lati: 39.786726  longi: 116.56192
// ios
const mapLocationParams = (location) => {
    return {
        lng: isIOS ? location.longitude : location.longi,
        lat: isIOS ? location.latitude : location.lati
    };
};

/**
 * 获取经纬度
 * @param businessId
 * ignoreJDLocationCache: 是否忽略主站缓存, 默认如果没有权限会取主站的缓存地址
 */
const getLatLng = (businessId = BIZ_ID) => {
    if (isWeb) {
        return new Promise((resolve, reject) => {
            getLatLngForWeb().then(lbs => {
                resolve(lbs)
            }).catch((e) => {
                reject()
            });
        });
    }
    return new Promise(async(resolve, reject) => {
        let latLng = await getCurrentLatLng(businessId).catch(async err => {
            console.log('getCurrentLatLng失败------', err);
            toast('getLatLng获取实时定位失败' + JSON.stringify(err));
            console.log(err);
            const cacheLatLng = await getJDAppCacheLatLng(businessId).catch(err => {
                toast('getLatLng实时定位和缓存都没拿到' + JSON.stringify(err));
                return reject(err);
            });
            toast('getLatLng拿到了缓存位置' + JSON.stringify(cacheLatLng));
            return cacheLatLng;
        });
        console.log('getCurrentLatLng成功123', latLng);
        if (!latLng || latLng.lat + '' === '0' || latLng.lng + '' === '0') {
            return reject(new Error('没有缓存也没有权限'));
        }
        toast('getLatLng获取实时定位成功' + JSON.stringify(latLng));
        resolve(latLng);
    });
};

const toast = (msg) => {
    toastcontent = toastcontent + '\n' + msg;
    // JDNativeToast.show(toastcontent);
    console.log(toastcontent);
};

export {
    getLatLng,
    manualRequestLocationPermission
};
